import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import DescriptionIcon from '@material-ui/icons/Description';
import { useCustomerDetailsStyles } from './CustomerDetails';
import PreferencesEdit from './PreferencesEdit';

const PreferencesRow = ({ customer }) => {
  const classes = useCustomerDetailsStyles();
  const translate = useTranslate();
  const [openPreferencesEdit, setOpenPreferencesEdit] = useState(false);

  const { id, is_opted_out_of_carfax_reporting } = customer || {};

  return (
    <Grid item>
      <Grid container spacing={1} alignItems="center" wrap="nowrap">
        <Grid item xs={1} className={classes.cardIcon}>
          <DescriptionIcon fontSize="large" />
        </Grid>
        <Grid item xs className={classes.cardTextContent}>
          <Typography className={classes.fw500}>
            {translate('resources.customer.subSections.carfax')}
          </Typography>
          <Typography>
            {is_opted_out_of_carfax_reporting ? 'Opted out' : 'Opted in'}
          </Typography>
        </Grid>
        <Grid item>
          <IconButton size="small" onClick={() => setOpenPreferencesEdit(true)}>
            <EditIcon />
          </IconButton>
        </Grid>
      </Grid>
      {openPreferencesEdit && (
        <PreferencesEdit
          openEdit={openPreferencesEdit}
          setOpenEdit={setOpenPreferencesEdit}
          id={id}
        />
      )}
    </Grid>
  );
};

export default PreferencesRow;
